import { vacanciesTypes } from '../actions/_vacancies_actions';

export default (state = [], action) => {
  switch (action.type) {
    case vacanciesTypes.FETCH_VACANCY_DATA:
      return [...action.vacancies];
    default:
      return state;
  }
};
